import { PaymentConfigActionTypes, PaymentConfigActions } from './payment-config.actions';
import { IPaymentConfig, ITaxSubsection, IPaymentOption, IPaymentProcessor } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IPaymentConfig[] | null;
    subsection: ITaxSubsection[] | null;
    paymentOption: IPaymentOption[] | null;
    paymentProcessor: IPaymentProcessor[] | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null,
    subsection: null,
    paymentOption: null,
    paymentProcessor: null
};

export function reducer(state = initialState, action: PaymentConfigActions): State {
    switch (action.type) {

        case PaymentConfigActionTypes.LoadPaymentConfigState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadPaymentConfigStateSuccess: {
            return {
                ...state,
                error: null,
                stateData: action.payload,
                pending: state.subsection === null || state.paymentOption === null || state.paymentProcessor === null
            };
        }
        case PaymentConfigActionTypes.UpdatePaymentConfigState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadPaymentConfigStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case PaymentConfigActionTypes.PaymentConfigScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case PaymentConfigActionTypes.LoadSubsectionsState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadSubsectionsStateSuccess: {
            return {
                ...state,
                error: null,
                subsection: action.payload,
                pending: state.paymentOption === null || state.paymentProcessor === null || state.stateData === null
            };
        }

        case PaymentConfigActionTypes.UpdateSubsectionsState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadPaymentOptionState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadPaymentOptionStateSuccess: {
            return {
                ...state,
                error: null,
                paymentOption: action.payload,
                pending: state.subsection === null || state.paymentProcessor === null || state.stateData === null
            };
        }

        case PaymentConfigActionTypes.UpdatePaymentOptionState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadPaymentProcessorState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadPaymentProcessorStateSuccess: {
            return {
                ...state,
                error: null,
                paymentProcessor: action.payload,
                pending: state.subsection === null || state.paymentOption === null || state.stateData === null
            };
        }

        case PaymentConfigActionTypes.UpdatePaymentProcessorState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentConfigActionTypes.LoadPaymentConfigStateInit: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;
export const getSubsectionData = (state: State) => state.subsection;
export const getPaymentOptionData = (state: State) => state.paymentOption;;
export const getPaymentProcessornData = (state: State) => state.paymentProcessor;